document.addEventListener("DOMContentLoaded", function () {
  initGiftVariantPrefixSync();
  applyGiftCode();
  // validateGiftCart();
  headerSearch();
  initHeaderDropdowns();
  initMenuDrawerSubmenus();
  // handleNestedSelection();
  // initCrossSellingPopup();
  wimAccordeon();
  customDropdown();
  setupVideoToggles();
  setTimeout(() => {
    if( document.querySelector(".UpPromote-customer-referral-signup-form") ) {
      changeLanguageUpPromoteCustomerReferral(document.querySelector(".UpPromote-customer-referral-signup-form"));
    }
  }, 1000);
});

function changeLanguageUpPromoteCustomerReferral( up_promote_customer_referral ) {
  if( up_promote_customer_referral.querySelector("label[for='uppromote-input-email']") ){
    document.querySelector("body").classList.remove("upp-customer-referral-existing");
  }
  else{
    document.querySelector("body").classList.add("upp-customer-referral-existing");
  }
  up_promote_customer_referral.querySelector("button").addEventListener("click", () => {
    document.querySelector("body").classList.add("upp-customer-referral-existing");
  });
}
/* --------------------------------------------------------------------------
   Synchronizes the selected product variant with a custom cart attribute ("Gift Prefix").
   Updates the attribute every time the variant input changes.
--------------------------------------------------------------------------- */
function initGiftVariantPrefixSync() {
  const variantInput = document.querySelector(".product__info-wrapper .product-variant-id");
  if (!variantInput) return;

  const tpl = document.querySelector('[id^="variant-prefix-map"]');
  if (!tpl) return;

  let variantMap;
  try {
    variantMap = JSON.parse(tpl.innerHTML);
  } catch (e) {
    return;
  }

  const hiddenInput = document.querySelector("#wim-gift-suscription");
  if (!hiddenInput) return;

  function updateCartAttribute(variantId) {
    const prefix = variantMap[variantId] || "";
    hiddenInput.value = prefix;

    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        attributes: { "Gift Prefix": prefix }
      })
    }).then(res => res.json());
  }

  variantInput.addEventListener("change", (event) => {
    updateCartAttribute(event.target.value);
  });

  if (variantInput.value) updateCartAttribute(variantInput.value);
}

/* --------------------------------------------------------------------------
   Handles the Gift Subscription code input logic.
   Validates format, maps code to product and subscription plans,
   clears the cart, adds the product, applies the discount and shows popups.
--------------------------------------------------------------------------- */
function applyGiftCode() {
  const t = theme.translates.webimpacto.subscriptions;
  const input = document.getElementById("gift-code-input");
  const button = document.getElementById("gift-code-submit");
  const message = document.getElementById("gift-code-message");

  if (!input || !button) return;

  const codeRegex = /^GF[A-Z0-9]+-[A-Z0-9]+-\d+$/;

  button.addEventListener("click", () => {
    const rawValue = input.value.trim().toUpperCase();
    input.value = rawValue;

    if (!codeRegex.test(rawValue)) {
      message.textContent = t.popup_invalid_code_title;
      message.style.color = "red";
      return;
    }

    message.textContent = "✔";
    message.style.color = "green";
    addGiftCodeToCart(rawValue);
  });

  /* ----------------------------------------------------------------------
    Parses code segments, finds matching variant and plan IDs,
    clears cart, adds product, applies discount, sets attributes.
  ---------------------------------------------------------------------- */
  async function addGiftCodeToCart(code) {
    const messageEl = document.getElementById("gift-code-message");

    function showSpinner() {
      if (!messageEl) return;
      messageEl.innerHTML = `
        <div class="gift-spinner" style="
          display:inline-block;
          width:18px;
          height:18px;
          border:2px solid #ccc;
          border-top-color:#000;
          border-radius:50%;
          animation:spin 0.8s linear infinite;
          vertical-align:middle;
        "></div>
      `;
    }

    function hideSpinner() {
      if (!messageEl) return;
      messageEl.innerHTML = "";
    }

    try {
      showSpinner();

      const key = code.substring(2).split("-")[0];


      const tplVariants = document.getElementById("gift-product-variant-map");
      const tplSubscriptions = document.getElementById("gift-suscription-map");

      if (!tplVariants || !tplSubscriptions) {
        hideSpinner();
        showPopupMessage(t.popup_error_config_title, t.popup_error_config_message);
        return;
      }

      const variantMap = JSON.parse(tplVariants.innerHTML);
      const subscriptionMap = JSON.parse(tplSubscriptions.innerHTML);

      const variantId = variantMap[key];
      const subscriptionId = subscriptionMap[key];

      if (!variantId || !subscriptionId) {
        hideSpinner();
        showPopupMessage(t.popup_invalid_code_title, t.popup_invalid_code_message);
        return;
      }


      const cartRes = await fetch("/cart.js");
      // if (!cartRes.ok) throw new Error("Error obteniendo el carrito");
      const cartData = await cartRes.json();
      const hasCartItems = cartData?.items?.length > 0;


      async function proceedAddGift() {
        showSpinner();

        await fetch("/cart/clear.js", { method: "POST" });

        const addRes = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1,
                selling_plan: Number(subscriptionId)
              }
            ]
          })
        });

        if (!addRes.ok) {
          hideSpinner();
          console.log("ha dado error?");
          showPopupMessage(t.popup_error_add_title, t.popup_error_add_message);
          return;
        }

        const discountRes = await fetch(`/discount/${encodeURIComponent(code)}`, {
          method: "GET",
          headers: { "Accept": "text/html" }
        });


        const cartCheck = await fetch("/cart.js", { method: "GET" });
        const cartAfterDiscount = await cartCheck.json();

        const appliedDiscount = cartAfterDiscount?.cart_level_discount_applications || [];

        const isApplied = appliedDiscount.some(d =>
          d.title?.toLowerCase() === code.toLowerCase()
        );

        if (!isApplied) {
          await fetch("/cart/clear.js", { method: "POST" });

          hideSpinner();
          showPopupMessage(t.popup_error_discount_title, t.popup_error_discount_message);
          return;
        }

        hideSpinner();

        showPopupMessage(
          t.popup_success_title,
          t.popup_success_message,
          () => { window.location.href = "/cart?gift_redirect=true"; }
        );
      }

      if (hasCartItems) {
        hideSpinner();
        showConfirmationPopup(
          t.popup_confirm_title,
          t.popup_confirm_message,
          proceedAddGift
        );
      } else {
        await proceedAddGift();
      }

    } catch (error) {
      hideSpinner();
      showPopupMessage(t.popup_unexpected_error_title, t.popup_unexpected_error_message);
    }
  }


  /* ---------------------------------------------------------------------- 
    Generic confirmation modal with title, message and accept button.
  ---------------------------------------------------------------------- */
  function showConfirmationPopup(title, message, onConfirm) {
    const popup = document.createElement("div");
    popup.className = "gift-popup-overlay";
    popup.innerHTML = `
      <div class="gift-popup">
        <button class="gift-popup-close" aria-label="Close">×</button>
        <h2>${title}</h2>
        <p>${message}</p>
        <div class="gift-popup-actions">
          <button class="gift-popup-accept">${t.popup_confirm_button}</button>
        </div>
      </div>
    `;
    document.body.appendChild(popup);

    const close = () => popup.remove();
    popup.querySelector(".gift-popup-close").addEventListener("click", close);
    popup.querySelector(".gift-popup-accept").addEventListener("click", () => {
      close();
      onConfirm?.();
    });

    requestAnimationFrame(() => popup.classList.add("is-active"));
  }

  /* ---------------------------------------------------------------------- 
    Simple modal used to show info or error messages with a single button.
  ---------------------------------------------------------------------- */
  function showPopupMessage(title, message, onClose) {
    const popup = document.createElement("div");
    popup.className = "gift-popup-overlay";
    popup.innerHTML = `
      <div class="gift-popup">
        <button class="gift-popup-close" aria-label="Close">×</button>
        <h2>${title}</h2>
        <p>${message}</p>
        <div class="gift-popup-actions">
          <button class="gift-popup-accept">${t.popup_cart_adjusted_button}</button>
        </div>
      </div>
    `;
    document.body.appendChild(popup);

    const close = () => {
      popup.remove();
      onClose?.();
    };

    popup.querySelector(".gift-popup-close").addEventListener("click", close);
    popup.querySelector(".gift-popup-accept").addEventListener("click", close);

    requestAnimationFrame(() => popup.classList.add("is-active"));
  }
}

/* -------------------------------------------------------------------------- 
  Validates the cart for Gift Subscription logic.
  If the gift product is present, removes all other products and invalid discounts,
  then shows an informative popup and refreshes the page.
--------------------------------------------------------------------------- */
async function validateGiftCart() {
  const t = theme.translates.webimpacto.subscriptions;

  try {
    const giftProductIds = theme.wim?.subscriptions?.gift_product_target_ids || [];
    if (!Array.isArray(giftProductIds) || giftProductIds.length === 0) return;

    const giftDiscountPattern = /^[A-Z0-9]+-\d+-\d+$/;

    const res = await fetch("/cart.js");
    if (!res.ok) throw new Error("Error fetching cart");
    const cart = await res.json();

    if (!cart.items || cart.items.length === 0) return;

    // Solo dejamos los productos que sean regalos (IDs dentro del array)
    const hasGiftProduct = cart.items.some(item => giftProductIds.includes(item.product_id));
    if (!hasGiftProduct) return;

    // Eliminamos todos los items que no sean regalos
    const extraItems = cart.items.filter(item => !giftProductIds.includes(item.product_id));

    if (cart.cart_level_discount_applications?.length > 0) {
      for (const discount of cart.cart_level_discount_applications) {
        const code = discount.title?.trim() || "";
        if (!giftDiscountPattern.test(code)) {
          await fetch("/discount", { method: "DELETE" });
        }
      }
    }

    if (extraItems.length === 0) return;

    for (const item of extraItems) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
    }

    const popup = document.createElement("div");
    popup.className = "gift-popup-overlay";
    popup.innerHTML = `
      <div class="gift-popup">
        <button class="gift-popup-close" aria-label="Close">×</button>
        <h2>${t.popup_cart_adjusted_title}</h2>
        <p>${t.popup_cart_adjusted_message}</p>
        <ul class="gift-popup-list">
          ${extraItems.map(item => `<li>${item.product_title} × ${item.quantity}</li>`).join("")}
        </ul>
        <div class="gift-popup-actions">
          <button class="gift-popup-accept">${t.popup_cart_adjusted_button}</button>
        </div>
      </div>
    `;
    document.body.appendChild(popup);

    requestAnimationFrame(() => popup.classList.add("is-active"));

    const closePopup = () => {
      popup.classList.remove("is-active");
      setTimeout(() => {
        popup.remove();
        location.reload();
      }, 300);
    };

    popup.querySelector(".gift-popup-close").addEventListener("click", closePopup);
    popup.querySelector(".gift-popup-accept").addEventListener("click", closePopup);
  } catch (error) {
    console.error("[GiftCart] Error validating cart:", error);
  }
}

function headerSearch() {
  const searchButton = document.querySelector(".wim-header-search-button");
  const closeButton = document.querySelector(".header__icons .icon-close");
  const menuButton = document.querySelector(".header__top .menu-drawer-button");
  const mobileSearch = document.querySelector(".header__search__mobile");
  const desktopSearch = document.querySelector(".header__search");
  const predectiveMenuMobile = document.getElementById("PredictiveMenuMobileSearchInput");

  if (searchButton) {
    searchButton.addEventListener("click", () => {
      desktopSearch.style.setProperty("display", "block", "important");
      const input = desktopSearch.querySelector("input");
      if (input) input.focus();
    });
  }

  if (closeButton) {
    closeButton.addEventListener("click", () => {
      desktopSearch.style.setProperty("display", "none", "important");
    });
  }

  if (menuButton && mobileSearch) {
    menuButton.addEventListener("click", () => {
      setTimeout(() => {
        const expanded = menuButton.getAttribute("aria-expanded") === "true";
        if (expanded) {
          mobileSearch.classList.add("active");
          document.body.classList.add("expanded-menu-mobile");
        } else {
          mobileSearch.classList.remove("active");
          document.body.classList.remove("expanded-menu-mobile");
        }
      }, 50);
    });
  }

  window.addEventListener("scroll", () => {
    desktopSearch.style.display = "none";
  });

  if (predectiveMenuMobile) {
    predectiveMenuMobile.addEventListener('input', function (e) {
      const desktopInput = document.querySelector("predictive-search .search__input");
      desktopInput.value = e.target.value;
      desktopInput.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }
}

function initHeaderDropdowns() {
  const dropdownButtons = document.querySelectorAll(
    ".header__help-trigger, .account-dropdown-toggle"
  );

  dropdownButtons.forEach((button) => {
    const expanded = button.getAttribute("aria-expanded") === "true";

    const dropdown = button.nextElementSibling;
    if (!dropdown || !dropdown.classList.contains("header__dropdown__menu")) return;

    button.addEventListener("click", (e) => {
      e.stopPropagation();

      closeAllDropdownsExcept(dropdown);

      const isExpanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", !isExpanded);
      dropdown.classList.toggle("active", !isExpanded);
    });
  });

  document.addEventListener("click", (e) => {
    const anyOpen = document.querySelector(".header__dropdown__menu.active");
    if (anyOpen && !anyOpen.contains(e.target)) {
      closeAllDropdownsExcept();
    }
  });

  function closeAllDropdownsExcept(exception) {
    document.querySelectorAll(".header__dropdown__menu.active").forEach((openMenu) => {
      if (openMenu !== exception) {
        openMenu.classList.remove("active");
        const relatedButton = openMenu.previousElementSibling;
        if (relatedButton?.getAttribute("aria-expanded")) {
          relatedButton.setAttribute("aria-expanded", "false");
        }
      }
    });
  }
}

function initMenuDrawerSubmenus() {
  const toggles = document.querySelectorAll(".js-submenu-toggle");
  toggles.forEach((toggle) => {
    toggle.addEventListener("click", () => {
      const expanded = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", !expanded);
      const submenu = toggle.nextElementSibling;
      submenu.classList.toggle("hidden", expanded);
    });
  });
}


document.addEventListener('product-ajax:added', async () => {
  // await validateGiftCart();
});



function wimAccordeon() {
  const wimAccordeons = document.querySelectorAll('.wim-enabled-accordeon');

  if (!wimAccordeons) return;

  wimAccordeons.forEach(item => {
    const wrapper = item.querySelector('multicolumn-icon');
    const content = item.querySelector('.multicolumn__items');

    if (!wrapper || !content) return;

    const realHeight = content.scrollHeight;
    wrapper.style.setProperty('--wim-height', realHeight + 'px');

    item.addEventListener('click', () => {
      item.classList.toggle('wim-open');
    });
  });
}

function customDropdown() {
  document.querySelectorAll('.fake-sort').forEach(wrapper => {
    if (wrapper.classList.contains('is-initialized')) return;
    wrapper.classList.add('is-initialized');

    const trigger = wrapper.querySelector('.fake-sort__trigger');
    const label = wrapper.querySelector('.fake-sort__label');
    const options = wrapper.querySelectorAll('.fake-sort__option');

    if (!trigger || !label || !options.length) return;

    const selectWrapper = wrapper.previousElementSibling?.classList.contains('select')
      ? wrapper.previousElementSibling
      : wrapper.nextElementSibling?.classList.contains('select')
        ? wrapper.nextElementSibling
        : null;

    const select = selectWrapper?.querySelector('select');
    if (!select) return;

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      wrapper.classList.toggle('is-open');
    });

    options.forEach(option => {
      option.addEventListener('click', (e) => {
        e.stopPropagation();

        const value = option.dataset.value;
        if (!value) return;

        label.textContent = option.textContent.trim();
        options.forEach(o => o.classList.remove('is-active'));
        option.classList.add('is-active');
        wrapper.classList.remove('is-open');

        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.addEventListener('click', () => {
    document.querySelectorAll('.fake-sort.is-open').forEach(el => {
      el.classList.remove('is-open');
    });
  });
}
FoxTheme.pubsub.subscribe(
  FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate,
  () => {
    console.log("re lanzado");
    customDropdown();
  }
);

// let waitingForCartJS = false;

// (function () {
//   const originalFetch = window.fetch;

//   window.fetch = function (...args) {
//     const url = args[0];

//     if (typeof url === "string" && (url.includes("/cart/add") || url.includes("/cart/change"))) {
//       waitingForCartJS = true;
//     }

//     if (waitingForCartJS && typeof url === "string" && url == "/cart") {
//       originalFetch.apply(this, args).then(res => {
//         res.clone().json().then(async (cart) => {

//           const not_allow_multiple_purchase = theme.wim.allow_multiple_purchase;
//           const items = cart.items;
//           let item_count = cart.item_count;

//           function getGroups(items) {
//             return items.map(item =>
//               item.properties && item.properties._group_id
//                 ? item.properties._group_id
//                 : `solo-${item.key}`
//             );
//           }

//           function getKeysToDelete(items, groups, newestGroup) {
//             return items
//               .filter((item, index) => groups[index] !== newestGroup)
//               .map(item => item.key);
//           }

//           async function deleteKeys(keys) {
//             if (!keys.length) return;

//             await new Promise(resolve => setTimeout(resolve, 200));

//             const liveCart = await fetch('/cart.js').then(r => r.json());
//             const liveItems = liveCart.items || [];

//             const liveKeys = liveItems.map(item => item.key);
//             const validKeysToDelete = keys.filter(k => liveKeys.includes(k));

//             if (!validKeysToDelete.length) return;
//             if (validKeysToDelete.length >= liveKeys.length) return;

//             const getGroups = (items) =>
//               items.map(item =>
//                 item.properties && item.properties._group_id
//                   ? item.properties._group_id
//                   : `solo-${item.key}`
//               );

//             const liveGroups = getGroups(liveItems);
//             const uniqueGroups = [...new Set(liveGroups)];

//             if (uniqueGroups.length <= 1) return;

//             const newestGroup = liveGroups[0];
//             const finalKeysToDelete = liveItems
//               .filter((item, index) => liveGroups[index] !== newestGroup)
//               .map(item => item.key);

//             const mismatch =
//               finalKeysToDelete.length !== validKeysToDelete.length ||
//               !finalKeysToDelete.every(k => validKeysToDelete.includes(k));

//             if (mismatch) return;

//             const updates = {};
//             finalKeysToDelete.forEach(k => updates[k] = 0);

//             await fetch('/cart/update.js', {
//               method: 'POST',
//               headers: { 'Content-Type': 'application/json' },
//               body: JSON.stringify({ updates })
//             });
//           }

//           if (not_allow_multiple_purchase) {
//             // const groups = getGroups(items);
//             // const uniqueGroups = [...new Set(groups)];

//             // if (uniqueGroups.length > 1) {
//             //   const newestGroup = groups[0];
//             //   const keysToDelete = getKeysToDelete(items, groups, newestGroup);

//             //   console.log(newestGroup);
//             //   console.log(items);

//             //   await deleteKeys(keysToDelete);
//             // }
//             // window.location.href = "/checkout";

//           } else {

//             const SuscripcionIds = theme.wim?.subscriptions?.gift_product_target_ids || [];

//             if (SuscripcionIds && SuscripcionIds.length > 0) {

//               let firstIsSuscripcion = false;
//               let existsSuscripcionNotFirst = false;

//               items.forEach((item, index) => {
//                 const isSuscripcion = SuscripcionIds.includes(item.product_id);

//                 if (index === 0 && isSuscripcion) firstIsSuscripcion = true;
//                 if (index > 0 && isSuscripcion) existsSuscripcionNotFirst = true;
//               });

//               if (firstIsSuscripcion) {
//                 const groups = getGroups(items);
//                 const newestGroup = groups[0];

//                 const keysToDelete = getKeysToDelete(items, groups, newestGroup);

//                 await deleteKeys(keysToDelete);

//                 // window.location.href = "/checkout";
//               }

//               else if (existsSuscripcionNotFirst) {
//                 const keysToDelete = items
//                   .filter(item => SuscripcionIds.includes(item.product_id))
//                   .map(item => item.key);

//                 await deleteKeys(keysToDelete);
//               }
//             }
//           }

//           waitingForCartJS = false;

//         }).catch(() => { });
//       }).catch(() => { });
//     }

//     return originalFetch.apply(this, args);
//   };
// })();
let recover_password_link = document.querySelector('.wim-recover-password-link');
let message_section = document.getElementById('shopify-section-template--25147932901749__rich_text_HtqP3x');
if (recover_password_link) {
  recover_password_link.addEventListener('click', function (e) {
    if (message_section) {
      message_section.style.display = 'none';
    }
  });
}
if (message_section) {
  if (window.location.href.indexOf('#recover') > -1) {
    message_section.style.display = 'none';
  }
  else {
    let message_section = document.getElementById('shopify-section-template--25147932901749__rich_text_HtqP3x');
    message_section.style.display = 'block';
  }
}
function activeCustomer(shopifyClient) {

  if (document.querySelector('.container-form--active-customer-app-block')) {

    /*
      Form Shopify App: la ejecucion de estos formularios es un poco compleja debido a que no es la etiqueta form
      la que envia los datos, sino que se utiliza fetch para enviar los datos a una url especifica
      Esta url: https://forms.shopifyapps.com/api/v2/form_submission

      Es la que realmente envia los datos del formulario de la app por lo tanto se creo una funcion que 
      intercepta los fetch de la pagina para poder ejecutar la consulta GraphQL en el momento indicado

      la idea es que cuando se envie el fetch de la url indicada, se ejecute la funcion customerRecover
      del cliente de Shopify Storefront API para que envie el email de recuperacion de contraseña si fuese el caso

      ya el formulario de la app se encarga de enviar el email de activacion de cuenta si fuese el caso, 
      esto por medio de un flujo en la app Shopify Flow

      Importante: no solo la url es importante, tambien el metodo debe ser POST y el body debe ser un string JSON,
      debido a que existe otra consulta que se hace con la misma url y el body es un FormData, que no permite obtener
      el email

      Para mas informacion sobre la consulta GraphQL customerRecover ver el archivo wim-storefront.js
    */
    const originalFetch = window.fetch;
    window.fetch = function (...args) {

      return originalFetch.apply(this, args).then((response) => {
        const [url, options] = args;
        if (
          url === 'https://forms.shopifyapps.com/api/v2/form_submission' &&
          options.method === 'POST' &&
          typeof options.body === 'string'
        ) {
          try {
            document.getElementById('recover').style.display = 'none';
            document.getElementById('recover-subtext').style.display = 'none';
            let body_json = JSON.parse(options.body);
            if (body_json && body_json?.email) {
              shopifyClient.customerRecover(body_json.email).then((res) => {
                console.log('Recovery email sent:', res);
                setTimeout(() => {
                  window.location.href = '/account/login';
                }, 20000);
              });
            }
          } catch (error) {
            console.error('Error occurred while sending recovery email:', error);
          }
        }
        return response;
      });
    };
  }
}
(function injectShopifyFormEmbedStyles() {
  const TARGET_SELECTOR = 'shopify-forms-embed';
  const IGNORE_SELECTOR = '[data-wim-ignore-form-embed-styles]'; // 👈 nuevo

  const CSS = `
  /* Example overrides inside the form embed shadow DOM */
  [role="dialog"] { padding-top: 20px !important; }
  form [id^="label-"] { top: 16px !important; }
  button, .btn {
    font-size: 100% !important;
    position: relative !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 0 0.4rem !important;
    cursor: pointer !important;
    transition: background 0.3s, color 0.3s !important;
    white-space: nowrap !important;
    background: rgb(2,56,56) !important;
    color: rgb(255,255,255) !important;
    border: 1px solid rgba(2,56,56, 1) !important;
    border-radius: 10.0rem !important;
    padding: 0 3.2rem !important;
    height: 4.8rem !important;
    line-height: 30px !important;
    font-family: "Open Sans", sans-serif !important;
    font-weight: 700 !important;
    letter-spacing: 0 !important;
    text-transform: none !important;
    box-sizing: border-box !important;
  }
  .btn--primary::before {
    position: absolute;
    content: "";
    width: 0;
    inset-block: -0.1rem;
    inset-inline-start: -0.1rem;
    background-color: rgb(255,255,255);
    transition: width .4s ease;
    z-index: 0;
    border-radius: inherit;
  }
  .btn:not(.btn--plain, .btn--underline, .btn--link, .btn--inherit) .btn__text {
    overflow: hidden;
    text-overflow: ellipsis;
    z-index: 1;
  }
  @media (hover: hover) and (pointer: fine) {
    .btn--primary:hover {
      color: rgb(2,56,56) !important;
    }
  }
  .btn:not(.btn--plain,.btn--underline,.btn--link,.btn--inherit) {
    z-index: 1;
    overflow: hidden;
    max-width: 100%;
  }
  @media (hover: hover) and (pointer: fine) {
    .btn:not(.btn--plain, .btn--underline, .btn--link, .btn--inherit):hover::before, .btn:not(.btn--plain, .btn--underline, .btn--link, .btn--inherit).btn--active::before, .btn-hover-wrapper:hover .btn:not(.btn--plain, .btn--underline, .btn--link, .btn--inherit)::before {
      width: calc(100% + 1px);
    }
  }
  input[type="text"]{
    border-radius: 3.4rem !important;
  }
  input[type="text"]:focus{
    box-shadow: 0 0 0 1px #023838 !important;
  }
  section[data-testid="banner-success"] h2,
  section[data-testid="banner-success"] p {
    color: rgb(2,56,56) !important;
  }
  section[data-testid="banner-success"] h2{
    font-size: 20px !important;
    font-weight: 600 !important;
    margin-bottom: 0rem !important;
  }
  section[data-testid="banner-success"] p {
    margin: 1.2rem 0 0 !important;
    font-size: 1.5rem !important;
    font-weight: 400 !important;
  }
  `;
  function tryInject(el) {
    try {
      if (!el || el.dataset.wimInjected) return;

      if (el.closest && el.closest(IGNORE_SELECTOR)) return;

      const sr = el.shadowRoot;
      if (!sr) return;
      const style = document.createElement('style');
      style.setAttribute('data-wim-inject', 'true');
      style.textContent = CSS;
      sr.appendChild(style);

      const submitBtn = sr.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.classList.add('btn', 'btn--primary');
        submitBtn.innerHTML = `<span class="btn__text">${submitBtn.textContent}</span>`;
      }

      el.dataset.wimInjected = '1';

      const shopifyClient = new ShopifyStorefrontClient();
      activeCustomer(shopifyClient);
    } catch (e) {
      console.error('[wim] error injecting styles into shadowRoot', e);
    }
  }

  // Inject into any existing embeds
  document.querySelectorAll(TARGET_SELECTOR).forEach(tryInject);

  // Observe DOM for new embeds
  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches && node.matches(TARGET_SELECTOR)) tryInject(node);
        const descendants = node.querySelectorAll ? node.querySelectorAll(TARGET_SELECTOR) : [];
        descendants.forEach(tryInject);
      }
    }
  });
  observer.observe(document.documentElement || document.body, { childList: true, subtree: true });

  // Retry pass for late-initialized shadowRoots (safety)
  let retries = 0;
  const maxRetries = 10;
  const retryInterval = setInterval(() => {
    document.querySelectorAll(TARGET_SELECTOR).forEach(tryInject);
    retries++;
    if (retries >= maxRetries) clearInterval(retryInterval);
  }, 500);
})();

function setupVideoToggles() {
  document.querySelectorAll(".product__media-item-container.media-type-video").forEach(container => {
    const videoElement = container.querySelector("video-element");
    const icon = container.querySelector(".video-state-icon");

    const playIcon = icon.querySelector(".icon-play");
    const pauseIcon = icon.querySelector(".icon-pause");

    playIcon.style.display = "none";
    pauseIcon.style.display = "block";

    // Click sobre el contenedor para toggle
    container.addEventListener("click", () => {
      if (videoElement.playing) {
        console.log("Video estaba reproduciéndose → pausa");
        videoElement.pause();
        playIcon.style.display = "block";
        pauseIcon.style.display = "none";
      } else {
        console.log("Video estaba pausado → reproducir");
        videoElement.play();
        playIcon.style.display = "none";
        pauseIcon.style.display = "block";
      }
    });

    videoElement.addEventListener("play", () => {
      console.log("Evento 'play' disparado");
      playIcon.style.display = "none";
      pauseIcon.style.display = "block";
    });

    videoElement.addEventListener("pause", () => {
      console.log("Evento 'pause' disparado");
      playIcon.style.display = "block";
      pauseIcon.style.display = "none";
    });
  });
}